import axios from 'axios';

const UPLOAD_URL =
  `${import.meta.env.VITE_UPLOAD_URL}/api/Upload/UploadFiles` ||
  'https://gate.shjinjia.com.cn/api/Upload/UploadFiles';

/** 开发文档约定：响应 JSON 包含文件路径字段，当前为 File，兼容 res_content、data、url */
function getFileUrlFromResponse(res) {
  if (!res || typeof res !== 'object') return '';
  const raw =
    res.res_content?.File ??
    res.res_content?.file ??
    res.File ??
    res.file ??
    res.data ??
    res.url;
  return typeof raw === 'string' ? raw : '';
}

/**
 * 上传文件（二进制 form-data）
 * 接口约定：POST /Upload/UploadFiles，响应需包含文件路径字段（如 File）
 * @param {File} file - 文件对象
 * @param {{ url?: string }} options - 可选，覆盖上传地址
 * @returns {Promise<{ File?: string, [key: string]: any }>} 返回接口原始响应；文件路径可用 getFileUrlFromResponse(res) 提取
 */
export const uploadFile = (file, options = {}) => {
  const formData = new FormData();
  formData.append('file', file);

  const token = localStorage.getItem('access_token');
  const url = options.url || UPLOAD_URL;
  return axios({
    url,
    method: 'post',
    data: formData,
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    timeout: 30000,
  }).then((res) => res.data);
};

export { getFileUrlFromResponse };
